/* TOMA PDP test: prevent unintended default size purchases. */
(function () {
  function isSizeControl(el) {
    if (!el || !el.dataset) return false;
    return /taglia|size|misura/i.test(el.dataset.optionName || '');
  }
  function setup(note) {
    if (note.dataset.tomaReady === 'true') return;
    const root = note.closest('product-info');
    if (!root) return;
    const findButton = () => root.querySelector('product-form button[name="add"]');
    const findPicker = () => Array.from(root.querySelectorAll('variant-selects .product-form__input'))
      .find(g => Array.from(g.querySelectorAll('[data-option-name]')).some(isSizeControl));
    const form = root.querySelector('product-form form');
    if (!form || !findPicker()) return;
    note.dataset.tomaReady = 'true';
    let confirmed = note.dataset.sizeConfirmed === 'true';
    const status = note.querySelector('[data-toma-size-status]');
    function showMessage(message) { if (status) status.textContent = message; }
    function syncLabel() {
      const btn = findButton();
      if (!btn || btn.disabled) return;
      const span = btn.querySelector('span');
      if (!span) return;
      if (!confirmed) span.textContent = 'Scegli la taglia';
      else if (span.textContent.trim() === 'Scegli la taglia') {
        span.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Aggiungi al carrello';
      }
    }
    function focusPicker() {
      const group = findPicker();
      if (!group) return;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      showMessage('Seleziona una taglia disponibile per continuare.');
      const label = group.querySelector('legend');
      if (label) label.setAttribute('tabindex', '-1');
      if (label) label.focus({ preventScroll: true });
    }
    function confirm(el) {
      if (!isSizeControl(el) || el.classList.contains('disabled') || el.disabled) return;
      confirmed = true;
      showMessage('');
      syncLabel();
      window.setTimeout(syncLabel, 250);
    }
    root.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects')) confirm(e.target);
    });
    root.addEventListener('click', (e) => {
      const label = e.target.closest('variant-selects label[for]');
      if (!label) return;
      const control = document.getElementById(label.htmlFor);
      if (control) confirm(control);
    });
    form.addEventListener('submit', (e) => {
      if (confirmed) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      focusPicker();
    }, true);
    syncLabel();
  }
  function init() { document.querySelectorAll('[data-toma-size-note]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
